import type { FundTransactionStatus } from '@/types/fund-transactions';

export const STATUS_BADGE_VARIANT: Record<
  FundTransactionStatus,
  'secondary' | 'default' | 'destructive' | 'outline'
> = {
  DRAFT: 'outline',
  ISSUED: 'secondary',
  APPROVED: 'default',
  POSTED: 'default',
  REVERSED: 'destructive',
};

export const STATUS_LABEL: Record<FundTransactionStatus, string> = {
  DRAFT: 'Draft',
  ISSUED: 'Issued',
  APPROVED: 'Approved',
  POSTED: 'Posted',
  REVERSED: 'Reversed',
};
